import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import posts from '../../data/posts';
import PostCard from '../../components/PostCard/PostCard';
import Stars from '../../components/Stars/Stars';
import './HomePage.css';

const postsBySlug = Object.fromEntries(posts.map((p) => [p.slug, p]));

const slides = [
  {
    url: '/images/farmhouse-logo.webp',
    label: 'Full English - Farmhouse',
    title: 'Full English - Farmhouse',
    subtitle: 'A solid, if a little expensive, Full English',
    to: '/post/farmhouse-full-english',
    slug: 'farmhouse-full-english',
    isNew: true,
  },
  {
    url: '/images/bettys.jpeg',
    label: 'Full English - Harlow Carr',
    title: 'Full English - Harlow Carr',
    subtitle: 'A solid full English, though the price point felt a little steep for what\'s on offer.',
    to: '/post/harlow-carr-bettys-full-english',
    slug: 'harlow-carr-bettys-full-english',
  },
];

function Slideshow() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const prev = () => setCurrent((c) => (c - 1 + slides.length) % slides.length);
  const next = () => setCurrent((c) => (c + 1) % slides.length);

  return (
    <div className="slideshow">
      <div
        className="slideshow-track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {slides.map((slide, i) => {
          const rating = postsBySlug[slide.slug]?.rating;
          return (
            <Link key={i} to={slide.to} className="slideshow-slide-link">
              <img src={slide.url} alt={slide.label} className="slideshow-slide" />
              {slide.isNew && <span className="slideshow-new-badge">New</span>}
              <div className="slideshow-caption">
                {rating && <Stars rating={rating} />}
                <h2 className="slideshow-caption-title">{slide.title}</h2>
                <p className="slideshow-caption-subtitle">{slide.subtitle}</p>
              </div>
            </Link>
          );
        })}
      </div>
      <button className="slideshow-btn slideshow-btn--prev" onClick={prev} aria-label="Previous slide">&#8249;</button>
      <button className="slideshow-btn slideshow-btn--next" onClick={next} aria-label="Next slide">&#8250;</button>
      <div className="slideshow-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`slideshow-dot${i === current ? ' active' : ''}`}
            onClick={() => setCurrent(i)}
          />
        ))}
      </div>
      <div className="slideshow-progress">
        <div key={current} className="slideshow-progress-bar" />
      </div>
    </div>
  );
}

function Hero() {
  return (
    <div className="hero">
      <p className="hero-eyebrow">A Yorkshire breakfast blog</p>
      <h1 className="hero-heading">Yorkshire Breakfasts, Honestly Reviewed</h1>
      <p className="hero-sub">Rated on quality, value, and that all-important runny yolk.</p>
    </div>
  );
}

function HomePage() {
  const [query, setQuery] = useState('');

  const sortedPosts = [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));

  const filtered = query.trim()
    ? sortedPosts.filter((p) => {
        const q = query.toLowerCase();
        return (
          p.title.toLowerCase().includes(q) ||
          p.blurb.toLowerCase().includes(q) ||
          (p.location && p.location.toLowerCase().includes(q)) ||
          (p.tags && p.tags.some((t) => t.toLowerCase().includes(q))) ||
          (p.searchTags && p.searchTags.some((t) => t.toLowerCase().includes(q)))
        );
      })
    : sortedPosts;

  return (
    <main className="home-page">
      {!query && <Hero />}
      {!query && <Slideshow />}
      <div className="search-bar-wrapper">
        <h2 className="search-heading">Find a breakfast</h2>
        <div className="search-bar">
          <svg className="search-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <circle cx="8.5" cy="8.5" r="5.5" stroke="currentColor" strokeWidth="1.6" />
            <path d="M13 13l3.5 3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
          <input
            type="search"
            className="search-input"
            placeholder="Search posts, tags, locations, menu items..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            aria-label="Search posts"
          />
          {query && (
            <button className="search-clear" onClick={() => setQuery('')} aria-label="Clear search">
              ✕
            </button>
          )}
        </div>
      </div>
      {filtered.length > 0 ? (
        <div className="post-grid">
          {filtered.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      ) : (
        <p className="search-empty">No posts found for &ldquo;{query}&rdquo;</p>
      )}
    </main>
  );
}

export default HomePage;
